import { useEffect, useState } from "react";
import S3Image from "../S3Image";
import "../../layouts/Styles.css";
import { connect } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { get, isEmpty, toUpper, truncate } from "lodash";
import { Actions } from "../../internals/app/Actions";
import AddProduct from "../../modules/product/views/AddProduct";
import { filterProductsBySearch } from "../../internals/managers/ProductManager";
import { formatPrice } from "../../internals/managers/PaymentManager";

const ProductGrid = (props: any) => {
  const {
    products,
    selectedShop,
    setImage,
    fetchProducts,
    selectedCategoryId,
    searchText = "",
  } = props;
  const [list, setList] = useState<Array<any>>([]);
  const [isOpenProduct, setIsOpenProduct] = useState<boolean>(false);
  const [selectedProduct, setSelectedProduct] = useState<any>({});

  useEffect(() => {
    if (products.products) {
      setList(products.products);
    }
  }, [products.products]);

  const getNameIcon = (name: string) => {
    if (name) {
      const character: any = name.match(/\b(\w)/g);
      return character.length === 2
        ? toUpper(character[0]) + toUpper(character[1])
        : toUpper(character[0]);
    }
  };

  useEffect(() => {
    if (!isEmpty(selectedProduct)) {
      toggleProduct();
      setImage(selectedProduct.productImage);
    }
  }, [selectedProduct]);

  const toggleProduct = () => {
    setIsOpenProduct(!isOpenProduct);
  };

  const fetchData = async () => {
    await fetchProducts(selectedShop.shopId, 100, products.nextLastKey);
  };

  // Filter by selected category; show all if none selected
  const categoryList = selectedCategoryId
    ? list.filter(
        (p: any) =>
          p.categoryResult?.categoryId === selectedCategoryId ||
          p.categoryId === selectedCategoryId
      )
    : list;

  const filteredList = filterProductsBySearch(categoryList, searchText);

  return (
    <InfiniteScroll
      dataLength={filteredList.length}
      next={fetchData}
      hasMore={!!products.nextLastKey}
      loader={<h4 className="text-sm text-gray-400 p-2">Loading...</h4>}
      endMessage={""}
      refreshFunction={() => {}}
      pullDownToRefresh
      pullDownToRefreshThreshold={50}
      pullDownToRefreshContent={""}
      releaseToRefreshContent={""}
      height="100%"
      style={{ height: "100%" }}
      className="h-full"
    >
      <div className="flex flex-row flex-wrap gap-3 pb-4">
        {/* Same reason as the list view: an empty grid with no message reads
            as an empty catalogue. */}
        {searchText && !isEmpty(list) && isEmpty(filteredList) && (
          <div className="w-full py-12 text-center">
            <p className="text-sm text-gray-600">
              No products match &ldquo;{searchText}&rdquo;
            </p>
            <p className="mt-1 text-xs text-gray-400">
              Try a shorter query, or search by category, brand or barcode.
            </p>
          </div>
        )}
        {filteredList.map((product: any, index: number) => {
          let price =
            get(product, "itemPrice", 0) || get(product, "itemSalePrice", 0);
          if (!isEmpty(product?.priceVariants)) {
            price = product.priceVariants.reduce(
              (min: any, obj: any) => (obj.price < min ? obj.price : min),
              product.priceVariants[0].price
            );
          }

          const isOptions =
            isEmpty(product.productImage) && product.productImages?.length > 0;
          const imageUrl = isOptions
            ? product.productImages[0]
            : product.productImage;

          const priceValue = formatPrice(price, selectedShop.currency);

          return (
            <div
              key={index}
              onClick={() => setSelectedProduct(product)}
              className="w-[150px] h-[210px] flex flex-col items-center self-center justify-between bg-white border border-gray-200 rounded-lg shadow-md cursor-pointer hover:shadow-lg transition-shadow duration-200"
            >
              {imageUrl ? (
                <S3Image
                  className="flex w-full object-contain h-[150px] overflow-hidden items-center justify-center bg-auto bg-no-repeat bg-center rounded-t-lg hover:scale-110 transition duration-300 ease-in-out"
                  url={imageUrl}
                  type={isOptions ? "menu" : null}
                />
              ) : (
                <div className="flex min-h-[135px] max-w-[150px] max-h-[150px] justify-center text-4xl items-center rounded-t-lg hover:scale-150 transition duration-300 ease-in-out text-[#201C53]">
                  {getNameIcon(product.productName)}
                </div>
              )}
              <div className="flex flex-col justify-center items-center p-2">
                <h6 className="text-xs font-medium tracking-tight text-gray-600 text-center capitalize">
                  {truncate(product.productName, { length: 100 })}
                </h6>
                <p className="text-sm font-normal text-gray-700">{priceValue}</p>
              </div>
            </div>
          );
        })}

        <AddProduct
          isOpen={isOpenProduct}
          product={selectedProduct}
          closeModal={() => toggleProduct()}
        />
      </div>
    </InfiniteScroll>
  );
};

export default connect(
  (state: any) => ({
    products: state.product.get("products"),
    categories: state.product.get("categories"),
    selectedShop: state.dashboard.get("selectedShop"),
  }),
  {
    setImage: Actions.product.setImage,
    fetchProducts: Actions.product.fetchProducts,
  }
)(ProductGrid);
